var HTML_FONT_SIZE = 16;
export default function pxToRem(size) {
  return "".concat(size / HTML_FONT_SIZE, "rem");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@shazambanking/sdk/styles/util/pxToRem.js
// module id = 228
// module chunks = 0